import { getContestData } from '../../cred';

export const initialContestData = {
	contests: [],
	nextContestsUpdate: undefined,
};

const getNewContestData = async () => {
	try {
		const { status, data } = await getContestData();

		if (status === 1) {
			const currentDate = Date.now() / 1000;
			let nextContestsUpdate;
			const contests = data.filter(({ startTime, endTime, on }) => {
				if (
					startTime &&
					startTime > currentDate &&
					(startTime < nextContestsUpdate || !nextContestsUpdate)
				) {
					nextContestsUpdate = startTime;
				}
				if (
					endTime &&
					endTime > currentDate &&
					(endTime < nextContestsUpdate || !nextContestsUpdate)
				) {
					nextContestsUpdate = endTime;
				}

				if (!!on && on !== 0 && on !== 1) {
					return false;
				}

				return true;
			});

			return {
				contests,
				nextContestsUpdate,
			};
		}
	} catch (error) {
		console.log('getContestData', error);
	}
	return {};
};

// ------------------------------------------------------------

export const contestActions = {
	/**
	 * Get Contest Data
	 */
	__checkContestData: getNewContestData,
};
